// extracted by mini-css-extract-plugin
export default {"dropdownUnit":"AllExistingProcesses_dropdownUnit__zj+sL","onShowUnit":"AllExistingProcesses_onShowUnit__TXnd-","footer":"AllExistingProcesses_footer__mym2J"};